import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Row, Col } from 'reactstrap'
import HighchartsReact from 'highcharts-react-official'
import { Highstock } from 'helpers/highcharts'

import * as user from 'commons'

import Kpi from '../kpi/Kpi'
import { cotationChart } from '../../helpers/initCharts'
import { rangeSelectorMarket } from '../../helpers/highcharts'
import { getKpiMarketElec, getMarketElecGraph } from '../../reducers/market'
import * as actions from '../../actions/market'

class MarketElec extends Component {
  componentDidMount() {
    this.fetchData()
  }

  fetchData() {
    const { fetchKpiMarketElec, fetchMarketElecGraph } = this.props
    fetchKpiMarketElec()
    fetchMarketElecGraph()
  }

  render() {
    const { kpi, graph, lng } = this.props

    return (
      <Col xs="4">
        <Row>
          <Col>
            <Kpi decimal={true} {...kpi} />
          </Col>
        </Row>
        <Row noGutters>
          <Col>
            <HighchartsReact
              highcharts={Highstock}
              constructorType="stockChart"
              options={cotationChart(graph, rangeSelectorMarket(lng), '#21215A')}
              immutable
            />
          </Col>
        </Row>
      </Col>
    )
  }
}

const mapStateToProps = (state) => ({
  kpi: getKpiMarketElec(state),
  graph: getMarketElecGraph(state),
  lng: Number(user.lanId(state)),
})

MarketElec.propTypes = {
  kpi: PropTypes.object,
  graph: PropTypes.object.isRequired,
  lng: PropTypes.number.isRequired,
}

export default connect(mapStateToProps, actions)(MarketElec)
